import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { currentUser, userRole, loading } = useContext(AuthContext);

  console.log('ProtectedRoute - currentUser:', currentUser);
  console.log('ProtectedRoute - userRole:', userRole);
  console.log('ProtectedRoute - requireAdmin:', requireAdmin);

  if (loading) {
    console.log('ProtectedRoute - Loading...');
    return <div>Ładowanie...</div>;
  }

  if (!currentUser) {
    console.log('ProtectedRoute - No user, redirecting to login');
    return <Navigate to="/login" />;
  }

  if (requireAdmin) {
    console.log('ProtectedRoute - Admin required');
    // Sprawdzenie czy użytkownik jest adminem lub marketingiem
    const isCurrentPathAddProduct = window.location.pathname === '/add-product';
    const hasAdminAccess = userRole === 'admin';
    const hasMarketingAccess = userRole === 'marketing' && isCurrentPathAddProduct;
    
    if (!hasAdminAccess && !hasMarketingAccess) {
      console.log('ProtectedRoute - User does not have required permissions, redirecting to /');
      return <Navigate to="/" />;
    }
  }

  console.log('ProtectedRoute - Access granted');
  return children;
};

export default ProtectedRoute;
